import React, { memo } from "react"
import { Marker, Tooltip } from "react-leaflet"
import { MapObject } from "api/mapview/mapview.pb"
import { DisplayValue } from "components/ui/utils"
import { useBaseModal, BaseModal } from "components/dialogs"
import { DDTViewer } from "components/datas"
import { ScreenEmpty } from "components/ui/screen"

interface SensorMarkerProps {
    object: MapObject
    onClick?: (object: MapObject) => void
    showTooltipPermanently?: boolean
    disableHoverTooltip?: boolean
}

const SensorMarker: React.FC<SensorMarkerProps> = ({ object, onClick, showTooltipPermanently = false, disableHoverTooltip = false }) => {
    const { open, handleOpen, handleClose } = useBaseModal()
    
    if (!object.coords) {
        return null
    }

    const position: [number, number] = [object.coords.x, object.coords.y]
    const displayValue = DisplayValue(object!.kind, object!.description)

    const handleClick = () => {
        if (onClick) {
            onClick(object)
        } else {
            if (object.description?.device_id) {
                handleOpen()
            } else {
                console.log('Clicked on marker:', object.name, object.id)
            }
        }
    }

    return (
        <>
        <Marker 
            position={position}
            eventHandlers={{
                click: handleClick
            }}
        >
            {!disableHoverTooltip ? (
                <Tooltip 
                    key={`tooltip-${object.id}-enabled`}
                    permanent={showTooltipPermanently}
                    interactive={false}
                >
                    <div>
                        <div><strong>{object.name}</strong></div>
                        <div style={{ color: displayValue?.color }}>
                            {displayValue?.text}
                        </div>
                    </div>
                </Tooltip>
            ) : (
                // Пустой компонент с ключом для принудительного обновления
                <div key={`tooltip-${object.id}-disabled`} style={{ display: 'none' }} />
            )}
        </Marker>            {/* Модальное окно с графиком */}
            <ScreenEmpty enabled={object.description?.device_id ? true : false}>
                <BaseModal 
                    title={object.name} 
                    open={open} 
                    onClose={handleClose} 
                    maxWidth="md" 
                    fullWidth
                    PaperProps={{
                        sx: {
                            height: '70vh',
                            maxHeight: '600px',
                            minHeight: '400px'
                        }
                    }}
                >
                    <ScreenEmpty enabled={object.description?.device_type === "ddt"}>
                        <DDTViewer 
                            id={object.description?.device_id!} 
                            realtime={false} 
                            showDatePanel={false} 
                            showChartPanel={false} 
                            showRangeslider={false}
                            maxLimit={100}
                        />
                    </ScreenEmpty>
                </BaseModal>
            </ScreenEmpty>
        </>
    )
}

function areEqual(prevProps: SensorMarkerProps, nextProps: SensorMarkerProps) {
    return (
        prevProps.object.id === nextProps.object.id &&
        prevProps.object.coords?.x === nextProps.object.coords?.x &&
        prevProps.object.coords?.y === nextProps.object.coords?.y &&
        prevProps.object.name === nextProps.object.name &&
        prevProps.object.description === nextProps.object.description &&
        prevProps.onClick === nextProps.onClick &&
        prevProps.showTooltipPermanently === nextProps.showTooltipPermanently &&
        prevProps.disableHoverTooltip === nextProps.disableHoverTooltip
    )
}

export default memo(SensorMarker, areEqual)
